import TemplateActionType from 'actions/template/templateActionType';

const initialState = {
  templates: {
    system: null,
    custom: null,
  },
  total: {
    system: 0,
    custom: 0,
  },
  template: {},
};

const templateReducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case TemplateActionType.SAVE_TEMPLATES:
    return {
      ...state,
      templates: payload.data,
    };
  case TemplateActionType.RESET_TEMPLATES:
    return {
      ...state,
      templates: {
        system: null,
        custom: null,
      },
      total: {
        system: 0,
        custom: 0,
      },
    };
  case TemplateActionType.SAVE_TEMPLATES_TOTAL:
    return {
      ...state,
      total: payload.data,
    };
  default:
    return state;
  }
};

export default templateReducer;
